export class AddServiceRequestModel{
    subject: string;
    comment: string;

}

